import { createAction } from '@ngrx/store';
import { OrganizationSiteInternalModel } from '@spog-ui/shared/models/sites';

export const loadSitesSuccessAction = createAction(
  '[Admin Organization / Sites State] Load Sites Success',
  (sites: OrganizationSiteInternalModel[]) => ({ sites }),
);
